module.exports = __webpack_public_path__ + "static/media/overview-selected.4ed85e40.svg";